import constants from "@/config/constants";

/**
 * A file the API serves out of its own `public/` folder, rather than a file this app ships.
 *
 * `VITE_API_URL` ends in the route namespace (`.../clients`), but static files sit at the API root, so
 * the last segment is dropped. Composed here rather than returned absolute by the backend, because the
 * backend answers on several hostnames — api.menuket.net, a LAN IP in development — and the one this
 * app should ask is the one it is already talking to.
 */
export const getApiAssetUrl = (path: string): string => {
    const base = (constants.url ?? "").replace(/\/+$/, "").replace(/\/[^/]*$/, "");
    return `${base}${path.startsWith("/") ? path : `/${path}`}`;
};
